import React, { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import axios from "axios";
import { GetAllPermission } from "../../URLs/Apis";
import { useSelector } from "react-redux";
import useDebounce from "../../hooks/useDebounce";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";

function Permissions() {
  const { user } = useSelector((state) => state.auth);

  const [searchForPermissions, setSearchForPermissions] = useState("");

  useEffect(() => {
    getPermissionsData();
  }, []);

  const [permissionsData, setPermissionsData] = useState([]);

  const getPermissionsData = () => {

    const headers = {
      Authorization: "Bearer " + user?.token,
    };

    axios
      .get(GetAllPermission, { headers })
      .then((response) => {
        setPermissionsData(response.data.data.permissions);
      })
      .catch((error) => {
        console.log(error.data);
      });
  };

  const debouncedSearchValue = useDebounce(searchForPermissions);

  return (
    <>
      <div className="MeanContant">
        <div className="w-50 mx-auto mt-3 w-lg-auto">
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="search-brands">
              Search for Permission Name ...
            </InputLabel>
            <OutlinedInput
              id="search-brands"
              type="text"
              onChange={(e) => {
                setSearchForPermissions((perv) => (perv = e.target.value));
              }}
              label="Search for Permission Name ..."
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
        <div className="permissionsList_Authoriztion">
          {permissionsData
            ?.filter((e) => e.name.toLowerCase().includes(debouncedSearchValue))
            .map((e, i) => {
              return (
                <div key={e.id} className="permissionsItem_Authoriztion">
                  {i + 1}. {e.name}
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default Permissions;
